<script lang="ts">
  import TipTapEditor from "$lib/admin/components/content/TipTapEditor/TipTapEditor.svelte";
  import { onMount } from "svelte";

  export let props: any = null;

  let hasParagraph = false;
  onMount(() => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(props.content, "text/html");
    hasParagraph = doc.querySelector("p") !== null;
  });
</script>

{#if props}
  <TipTapEditor bind:text={props.content} placeholder="Write some great content" />
{/if}
